import { createBrowserHistory } from 'history';
import { APP_PREFIX, BASE_PATH } from '../base/config';

const history = createBrowserHistory({
    basename: '/' + APP_PREFIX + '/' + BASE_PATH,
});

export default history;
